import { useEffect, useRef, useState } from "react";

// Navigasi keyboard untuk kotak pencarian dgn daftar hasil (seperti pencarian di POS/pelanggan):
// ketik lalu tekan panah bawah untuk menyorot hasil, panah atas/bawah untuk pindah, Enter untuk pilih.
export function useListNav(items, onSelect) {
  const [active, setActive] = useState(-1);
  const listRef = useRef(null);

  useEffect(() => {
    setActive(-1);
  }, [items.length]);

  useEffect(() => {
    if (active < 0 || !listRef.current) return;
    const el = listRef.current.querySelector(`[data-nav-index="${active}"]`);
    if (el) el.scrollIntoView({ block: "nearest" });
  }, [active]);

  const onInputKeyDown = (e) => {
    if (!items.length) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActive((a) => Math.min(items.length - 1, a + 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActive((a) => Math.max(0, a - 1));
    } else if (e.key === "Enter") {
      if (active >= 0 && active < items.length) {
        e.preventDefault();
        onSelect(items[active]);
      }
    } else if (e.key === "Escape") {
      setActive(-1);
    }
  };

  return { active, setActive, listRef, onInputKeyDown };
}
